import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ComponentStore, OnStoreInit } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs';
import { selectIsNewOrder } from './cart.reducer';

interface CartState {
    currentTabIndex: 0 | 1;
}

@UntilDestroy()
@Injectable()
export class CartPageStore extends ComponentStore<CartState> implements OnStoreInit {
    private readonly store = inject(Store);

    readonly currentTabIndex$ = this.select(state => state.currentTabIndex);

    constructor() {
        super(<CartState>{
            currentTabIndex: 0
        });
    }

    readonly setCurrentTabIndex = this.updater(
        (state, currentTabIndex: number): CartState => ({
            ...state,
            currentTabIndex: currentTabIndex as 0 | 1
        })
    );

    ngrxOnStoreInit(): void {
        this.store
            .select(selectIsNewOrder)
            .pipe(
                untilDestroyed(this),
                filter(isNewOrder => isNewOrder),
                tap(() => {
                    this.setCurrentTabIndex(0);
                })
            )
            .subscribe();
    }
}
